export const COOKIE_KEYS = {
  JWT: 'M4rP>pF%RN{2v8%B',
};

export const VERIFICATION_STATUS = {
  PENDING_REVIEW: 'pending_review',
  APPROVED: 'approved',
  RESUBMIT: 'resubmitted',
  REJECTED: 'rejected',
};

export const ADMIN_TYPES = {
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
};

export enum SUBSCRIPTION_PLAN_CATEGORY {
  BUSINESS_REGULAR = 'business_regular',
  BUSINESS_FREE_TRIAL = 'business_free_trial',
}

export enum BATCH_CLOSED_REASONS {
  TIME_EXPIRED = 'time_expired',
  CAPACITY_FULL = 'capacity_full',
  SCHEDULED_DISPATCH_WINDOW = 'scheduled_dispatch_window',
  ADMIN_MANUAL = 'admin_manual',
  ADMIN_MERGED = 'admin_merged',
  ADMIN_SPLIT_EMPTY = 'admin_split_empty',
}
export enum BATCH_STATUSES {
  FORMING = 'forming', // open window — accepting new orders
  CLOSED = 'closed', // window expired / capacity full
  PENDING_PAYMENT = 'pending_payment', // awaiting merchant Confirm & Dispatch
  DISPATCHED = 'dispatched', // broadcast sent to drivers
  IN_PROGRESS = 'in_progress', // a driver accepted the batch
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  BATCH_PRICE_UPDATE = 'batch_price_update',
  RATED_BY_USER = 'rated_by_user',
  SCHEDULED = 'scheduled',
  MERGED = 'merged',
}

export enum BATCH_TYPES {
  SINGLE_MERCHANT = 'single_merchant',
  CROSS_MERCHANT = 'cross_merchant',
}